module.exports = __webpack_public_path__ + "img/tipp-arrow.ad2dcc2c.svg";